<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table
    (detail)="onDetail($event)"
    (remove)="onRemove($event)"
    [columns]="columns"
    [dataProvider]="compositionTypeService"
    [title]="title"
  ></data-table>
</page-content>
